import { Type } from 'class-transformer';

export class ProjectTaskStatsRes {
    taskId: string = '';
    name: string = '';

    @Type(() => Date)
    currentStart: Date = new Date();

    @Type(() => Date)
    currentEnd: Date = new Date();

    plannedTaskHours: number = 0;
    plannedAppointmentHours: number = 0;
    actualWorkedHours: number = 0;

    constructor(data?: Partial<ProjectTaskStatsRes>) {
        Object.assign(this, data);
    }
}

export class CalendarExportFormConfig  {
    start!: Date;
    end!: Date;
    selectedProject?: number;
    availableProjects?: ProjectStatsRes[] | null;
    availableUsers?: ProjectUserStatsRes[] | null;
    separateFiles?: boolean;

    constructor(data: Partial<CalendarExportFormConfig>) {
        Object.assign(this, data);
    }
}

export class ProjectUserStatsRes {
    userId: number = 0;
    userName: string = '';
    plannedAppointmentHours: number = 0;
    actualWorkedHours: number = 0;

    constructor(data?: Partial<ProjectUserStatsRes>) {
        Object.assign(this, data);
    }
}

export class ProjectYearStatsRes {
    year: number = 0;

    appointmentCount: number = 0;
    workTimeEntryCount: number = 0;

    plannedAppointmentHours: number = 0;
    actualWorkedHours: number = 0;
    plannedVsActualDeltaHours: number = 0;

    @Type(() => ProjectUserStatsRes)
    users: ProjectUserStatsRes[] = [];

    constructor(data?: Partial<ProjectYearStatsRes>) {
        Object.assign(this, data);
    }
}

export class ProjectStatsRes {
    projectId: number = 0;
    name: string = '';
    customerId: number = 0;
    customerName: string = '';
    customerHasAddress: boolean = false;

    @Type(() => Date)
    requestedFromUtc?: Date | null = null;

    @Type(() => Date)
    requestedToUtc?: Date | null = null;

    @Type(() => Date)
    coverageFromUtc?: Date | null = null;

    @Type(() => Date)
    coverageToUtc?: Date | null = null;

    taskCount: number = 0;
    teamMemberCount: number = 0;

    appointmentCount: number = 0;
    workTimeEntryCount: number = 0;
    recentWorklogCount: number = 0;

    plannedTaskHours: number = 0;
    plannedAppointmentHours: number = 0;
    actualWorkedHours: number = 0;
    plannedVsActualDeltaHours: number = 0;

    projectVolumeBrutto?: number | null = null;
    projectVolumeBruttoOpen: number = 0;

    @Type(() => ProjectTaskStatsRes)
    tasks: ProjectTaskStatsRes[] = [];

    @Type(() => ProjectUserStatsRes)
    users: ProjectUserStatsRes[] = [];

    @Type(() => ProjectYearStatsRes)
    years: ProjectYearStatsRes[] = [];

    constructor(data?: Partial<ProjectStatsRes>) {
        Object.assign(this, data);
    }
}

export class CompanyProjectYearStatsRes {
    year: number = 0;
    projectCount: number = 0;

    totalPlannedAppointmentHours: number = 0;
    totalActualWorkedHours: number = 0;
    totalPlannedVsActualDeltaHours: number = 0;

    @Type(() => ProjectUserStatsRes)
    users: ProjectUserStatsRes[] = [];

    constructor(data?: Partial<CompanyProjectYearStatsRes>) {
        Object.assign(this, data);
    }
}

export class CompanyProjectStatsRes {
    companyId: number = 0;
    companyName: string = '';

    executingCompanyId!: number;
    executingCompanyName: string = '';

    @Type(() => Date)
    requestedFromUtc?: Date | null = null;

    @Type(() => Date)
    requestedToUtc?: Date | null = null;

    @Type(() => Date)
    coverageFromUtc?: Date | null = null;

    @Type(() => Date)
    coverageToUtc?: Date | null = null;

    projectCount: number = 0;

    totalPlannedTaskHours: number = 0;
    totalPlannedAppointmentHours: number = 0;
    totalActualWorkedHours: number = 0;
    totalPlannedVsActualDeltaHours: number = 0;

    totalProjectVolumeBrutto: number = 0;
    totalProjectVolumeBruttoOpen: number = 0;

    @Type(() => ProjectUserStatsRes)
    users: ProjectUserStatsRes[] = [];

    @Type(() => CompanyProjectYearStatsRes)
    years: CompanyProjectYearStatsRes[] = [];

    @Type(() => ProjectStatsRes)
    projects: ProjectStatsRes[] = [];

    constructor(data?: Partial<CompanyProjectStatsRes>) {
        Object.assign(this, data);
    }
}

export class ProjectStatsQueryReq {
    @Type(() => Date)
    fromUtc?: Date | null = null;

    @Type(() => Date)
    toUtc?: Date | null = null;

    projectIds?: number[] | null = null;
    customerIds?: number[] | null = null;
    years?: number[] | null = null;

    constructor(data?: Partial<ProjectStatsQueryReq>) {
        Object.assign(this, data);
    }
}